
// useEffect(() => {
//   if (referenceType === 'brand') {
//     axios.get(`https://vantara.datacubeglobal.com/api/products_by_Brand/${reference_id}`)
//       .then(res => setProducts(res.data.data));
//   } else if (referenceType === 'subcategory') {
//     axios.get(`https://vantara.datacubeglobal.com/api/products_by_SubCategory/${reference_id}`)
//       .then(res => setProducts(res.data.data));
//   }
// }, [referenceType, reference_id]);
//   useEffect(() => {
//    const fetchProducts = async () => {
//     const token = getAuthToken();

//     if (!token) {
//       setShowLoginModal(true);

//     }

//     try {
//       setLoading(true);

//       let apiUrl = 'https://vantara.datacubeglobal.com/api/products';
//       let axiosConfig = {};


//       if (!categoryId) {
//         axiosConfig = {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         };
//       }

//       // If categoryId exists, change the URL (no headers)
//       if (categoryId) {
//         apiUrl = `https://vantara.datacubeglobal.com/api/products_by_category/${categoryId}`;
//       }

//       const res = await axios.get(apiUrl, axiosConfig);
//       const data = res.data;


//         if (data.status === 'success') {
//   const mappedProducts = data.data.map((p) => {
//     // dynamically decide price to show
//     let displayPrice = 0;

//     switch (p.primary_price) {
//       case 'mrp':
//         displayPrice = parseFloat(p.mrp);
//         break;
//       case 'special_price':
//         displayPrice = parseFloat(p.special_price);
//         break;
//       case 'retail':
//         displayPrice = parseFloat(p.retail);
//         break;
//       case 'wholesale':
//         displayPrice = parseFloat(p.wholesale);
//         break;
//       default:
//         displayPrice = parseFloat(p.mrp); 
//     }

//     return {
//       id: p.product_id,
//       product_id: p.product_id,
//       name: p.product_name,
//       price: displayPrice,
//       originalPrice: parseFloat(p.mrp),
//         is_wishlisted: p.is_wishlisted || false,
//      image: p.primary_image ? `https://vantara.datacubeglobal.com/vantara/storage/app/public/${p.primary_image}` : '',
//       category: p.category || 'Others',
//       isSale:
//         parseFloat(p.special_price) > 0 &&
//         parseFloat(p.special_price) < parseFloat(p.mrp),
//     };
//   });

//   setProducts(mappedProducts);
//   setFilteredProducts(mappedProducts);

//   mappedProducts.forEach((p) => console.log('Product image URL:', p.image));
// }

//       } catch (error) {
//         console.error('Error fetching products:', error);
//       } finally {
//         setLoading(false); // stop loading
//       }
//     };


//     fetchProducts();
//   }, [categoryId]);




import React, { useEffect, useState } from 'react';
import WishlistModal from '../Modal/WishListModal';
import WishListModal from '../Modal/WishListModal';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import QuickViewModal from '../Modal/QuickViewModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FilterSidebar from '../Modal/FilterSidebar';
import axios from 'axios';
import ProductModal from '../Modal/ProductModal';
import Swal from 'sweetalert2';
import LoginModal from '../Modal/LoginModal';
import Noimage from '../../Images/Noimage.svg';

const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
const ProductListing = () => {

  const navigate = useNavigate();
  const { categoryId, referenceType, reference_id, subcategoryId } = useParams();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [priceRange, setPriceRange] = useState([0, 500]);
  const [sortBy, setSortBy] = useState('all');
  const [showQuickView, setShowQuickView] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const categories = ['All'];
  const [showQuickViewModal, setShowQuickViewModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(20);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category")

  const [allProducts, setAllProducts] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const fetchProducts = async (featuredOnly = false) => {
    try {
      setLoading(true);

      let apiUrl = "";
      let axiosConfig = {};
      const token = getAuthToken();


      if (referenceType === "brand") {
        apiUrl = `https://vantara.datacubeglobal.com/api/products_by_Brand/${reference_id}`;
      } else if (referenceType === "subcategory" || subcategoryId) {
        apiUrl = `https://vantara.datacubeglobal.com/api/products_by_SubCategory/${reference_id || subcategoryId}`;
      } else if (referenceType === "category" || categoryId) {

        apiUrl = `https://vantara.datacubeglobal.com/api/products_by_category/${reference_id || categoryId}`;
      }
      else if (category) {
        apiUrl = `https://vantara.datacubeglobal.com/api/api-products?category_name=${encodeURIComponent(category)}`;
        axiosConfig = {};
      }

      else {
        apiUrl = "https://vantara.datacubeglobal.com/api/api-products";
        // if (!token) setShowLoginModal(true);
        axiosConfig = {
          headers: { Authorization: `Bearer ${token}` },
        };
      }



      const res = await axios.get(apiUrl, axiosConfig);
      const data = res.data;

      if (data.status === "success") {
        let productsData = data.data;
        if (featuredOnly) {
          productsData = productsData.filter(p => p.is_featured === true);
        }

        // const mappedProducts = data.data.map((p) => {
        //   let displayPrice = 0;

        //   switch (p.primary_price) {
        //     case "mrp":
        //       displayPrice = parseFloat(p.mrp);
        //       break;
        //     case "special_price":
        //       displayPrice = parseFloat(p.special_price);
        //       break;
        //     case "retail":
        //       displayPrice = parseFloat(p.retail);
        //       break;
        //     case "wholesale":
        //       displayPrice = parseFloat(p.wholesale);
        //       break;
        //     default:
        //       displayPrice = parseFloat(p.mrp);
        //   }
        //   const originalPrice = parseFloat(p.mrp);
        //   const specialPrice = parseFloat(p.special_price);
        //   const discountPercent = Math.round(
        //     Math.abs(((p.mrp - p.special_price) / p.mrp) * 100)
        //   );


        //   return {
        //     id: p.product_id,
        //     product_id: p.product_id,
        //     name: p.product_name,
        //     price: displayPrice,
        //     stock: p.stock,
        //     // originalPrice: parseFloat(p.mrp),
        //     originalPrice: originalPrice,
        //     is_wishlisted: p.is_wishlisted || false,
        //     is_featured: p.is_featured || false,
        //     image: p.primary_image
        //       ? `https:\/\/vantara.datacubeglobal.com\/storage/${p.primary_image}`
        //       : "",
        //     category: p.category || "Others",
        //     // isSale:
        //     //   parseFloat(p.special_price) > 0 &&
        //     //   parseFloat(p.special_price) < parseFloat(p.mrp),
        //     isSale: specialPrice > 0 && specialPrice < originalPrice,
        //     discountPercent: discountPercent,
        //   };
        // });
        const mappedProducts = data.data.map((p) => {
          let displayPrice = 0;
          let cutPrice = 0;


          if (p.offer && p.offer_price) {
            displayPrice = parseFloat(p.offer_price);


            if (p.offer.discount_from === "mrp") {
              cutPrice = parseFloat(p.mrp);
            } else if (p.offer.discount_from === "srp") {
              cutPrice = parseFloat(p.special_price);
            } else {
              cutPrice = parseFloat(p.mrp);
            }
          } else {

            switch (p.primary_price) {
              case "mrp":
                displayPrice = parseFloat(p.mrp);
                break;
              case "special_price":
                displayPrice = parseFloat(p.special_price);
                break;
              case "retail":
                displayPrice = parseFloat(p.retail);
                break;
              case "wholesale":
                displayPrice = parseFloat(p.wholesale);
                break;
              default:
                displayPrice = parseFloat(p.mrp);
            }
            cutPrice = parseFloat(p.mrp);
          }

          const discountPercent = cutPrice > displayPrice
            ? Math.round(((cutPrice - displayPrice) / cutPrice) * 100)
            : 0;

          return {
            id: p.product_id,
            product_id: p.product_id,
            name: p.product_name,
            price: displayPrice,
            stock: p.stock,
            originalPrice: cutPrice,
            is_wishlisted: p.is_wishlisted || false,
            hasOffer: p.offer_price !== null,
            offerPrice: p.offer_price,
            offer: p.offer,
            is_featured: p.is_featured || false,
            image: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",
            category: p.category || "Others",
            isSale: displayPrice < cutPrice,
            discountPercent: discountPercent,
          };
        });
        setProducts(mappedProducts);
        setFilteredProducts(mappedProducts);
        if (!featuredOnly) {
          setAllProducts(mappedProducts);
        }

        return mappedProducts;
      } else {
        // Unexpected response
        setProducts([]);
        setFilteredProducts([]);
        if (!featuredOnly) setAllProducts([]);
        return [];
      }



    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, [referenceType, reference_id, categoryId, category]);

  // Fetch ONLY featured products from dedicated API
  const fetchFeaturedProducts = async () => {
    try {
      setLoading(true);
      const token = getAuthToken();
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

      const res = await axios.get("https://vantara.datacubeglobal.com/api/featured-prods", config);
      const data = res.data;

      if (data.status === "success") {
        const mappedProducts = data.data.map((p) => {
          let displayPrice = parseFloat(p.mrp); // fallback

          if (p.primary_price === "special_price" && p.special_price) {
            displayPrice = parseFloat(p.special_price);
          } else if (p.primary_price === "retail" && p.retail) {
            displayPrice = parseFloat(p.retail);
          } else if (p.primary_price === "wholesale" && p.wholesale) {
            displayPrice = parseFloat(p.wholesale);
          }

          const originalPrice = parseFloat(p.mrp);
          const specialPrice = parseFloat(p.special_price);
          const discountPercent = originalPrice > specialPrice ? Math.round(((originalPrice - specialPrice) / originalPrice) * 100) : 0;


          return {
            id: p.product_id,
            product_id: p.product_id,
            name: p.product_name,
            price: displayPrice,
            stock: p.stock,
            originalPrice: originalPrice,
            is_wishlisted: p.is_wishlisted || false,
            is_featured: true,
            hasOffer: p.offer_price !== null,   // ⭐ ADD THIS
            offerPrice: p.offer_price,          // ⭐ USE THIS IN BADGE
            offer: p.offer,                     // optional full offer details
            image: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",
            category: p.category || "Others",
            isSale: specialPrice > 0 && specialPrice < originalPrice,
            discountPercent: discountPercent,
          };
        });

        setProducts(mappedProducts);
        setFilteredProducts(mappedProducts);
        setAllProducts(mappedProducts);
      }
    } catch (error) {
      console.error("Error fetching featured products:", error);
      // Optionally show error toast
    } finally {
      setLoading(false);
    }
  };
  const ProductSkeleton = () => (
    <div className="col">
      <div className="card h-100 product-card">
        <div className="skeleton skeleton-img"></div>
        <div className="card-body">
          <div className="skeleton skeleton-text w-75 mb-2"></div>
          <div className="skeleton skeleton-text w-50"></div>
        </div>
      </div>
    </div>
  );


  // Lock scroll when QuickView is open
  useEffect(() => {
    if (showQuickView) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
  }, [showQuickView]);

  // const handleCategoryFilter = (category) => {
  //   setSelectedCategory(category);
  //   setSelectedSubCategory(null);

  //   if (category.id === "all") {
  //     setFilteredProducts(products);
  //   } else {
  //     const filtered = products.filter(p => p.category === category.name);
  //     setFilteredProducts(filtered);
  //   }
  // };

  const fetchAllProducts = async () => {
    try {
      setLoading(true);
      const token = getAuthToken();
      const res = await axios.get("https://vantara.datacubeglobal.com/api/api-products", {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });


      if (res.data?.status === "success" && Array.isArray(res.data.data)) {
        const mapped = res.data.data.map((p) => {
          let displayPrice = 0;
          switch (p.primary_price) {
            case "mrp":
              displayPrice = parseFloat(p.mrp);
              break;
            case "special_price":
              displayPrice = parseFloat(p.special_price);
              break;
            case "retail":
              displayPrice = parseFloat(p.retail);
              break;
            case "wholesale":
              displayPrice = parseFloat(p.wholesale);
              break;
            default:
              displayPrice = parseFloat(p.mrp);
          }

          const originalPrice = parseFloat(p.mrp);
          const specialPrice = parseFloat(p.special_price);
          const discountPercent = originalPrice > specialPrice ? Math.round(((originalPrice - specialPrice) / originalPrice) * 100) : 0;


          return {
            id: p.product_id,
            product_id: p.product_id,
            name: p.product_name,
            price: displayPrice,
            stock: p.stock,
            originalPrice: originalPrice,
            is_wishlisted: p.is_wishlisted || false,
            is_featured: p.is_featured || false,
            image: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",
            category: p.category || "Others",
            isSale: specialPrice > 0 && specialPrice < originalPrice,
            discountPercent: discountPercent,
          };
        });

        setProducts(mapped);
        setFilteredProducts(mapped);
        setAllProducts(mapped);
      } else {

        console.warn("Unexpected API response:", res.data);
        setProducts([]);
        setFilteredProducts([]);
      }
    } catch (err) {
      console.error("Error in fetchAllProducts:", err);
      setProducts([]);
      setFilteredProducts([]);
    } finally {
      setLoading(false);
    }
  };


  const handleCategoryFilter = async (category) => {
    setSelectedCategory(category);
    setSelectedSubCategory(null);

    if (category.id === "all") {
      await fetchAllProducts();
    } else {
      try {
        const res = await axios.get(
          `https://vantara.datacubeglobal.com/api/products_by_category/${category.id}`
        );

        if (res.data.status === "success") {
          const mapped = res.data.data.map((p) => {
            const originalPrice = parseFloat(p.mrp);
            const specialPrice = parseFloat(p.special_price);
            const discountPercent = originalPrice > specialPrice ? Math.round(((originalPrice - specialPrice) / originalPrice) * 100) : 0;

            return {
              id: p.product_id,
              product_id: p.product_id,
              name: p.product_name,
              price: parseFloat(p[p.primary_price] || p.mrp || 0),
              originalPrice: originalPrice,
              stock: p.stock,
              is_wishlisted: p.is_wishlisted || false,
              is_featured: p.is_featured || false,
              image: p.primary_image
                ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
                : "",
              category: p.category || "Others",
              sub_category: p.sub_category || "",
              discountPercent: discountPercent,
            };
          });

          setFilteredProducts(mapped);
          setAllProducts(mapped);
        } else {
          setFilteredProducts([]);
        }
      } catch (err) {
        console.error("Error filtering by category:", err);
        setFilteredProducts([]);
      }
    }
  };

  // When subcategory is clicked
  const handleSubCategoryFilter = async (subCategory) => {
    setSelectedSubCategory(subCategory);

    try {
      const res = await axios.get(
        `https://vantara.datacubeglobal.com/api/products_by_SubCategory/${subCategory.id}`
      );

      if (res.data.status === "success" && res.data.data.length > 0) {
        const mapped = res.data.data.map((p) => {
          const originalPrice = parseFloat(p.mrp);
          const specialPrice = parseFloat(p.special_price);
          const discountPercent = originalPrice > specialPrice ? Math.round(((originalPrice - specialPrice) / originalPrice) * 100) : 0;

          return {
            id: p.product_id,
            product_id: p.product_id,
            name: p.product_name,
            price: parseFloat(p[p.primary_price] || p.mrp || 0),
            originalPrice: originalPrice,
            stock: p.stock,
            is_wishlisted: p.is_wishlisted || false,
            is_featured: p.is_featured || false,
            image: p.primary_image
              ? `https://vantara.datacubeglobal.com/storage/${p.primary_image}`
              : "",
            category: p.category || "Others",
            sub_category: p.sub_category || "",
            discountPercent: discountPercent,
          };
        });

        setFilteredProducts(mapped);
        setAllProducts(mapped);
      } else {
    
        setFilteredProducts([]);
      }
    } catch (err) {
      console.error("Error filtering by subcategory:", err);
      setFilteredProducts([]);
    }
  };
  // const handleQuickAdd = (productId) => {
  //   const token = getAuthToken();

  //   if (!token) {
  //     setShowLoginModal(true);
  //     return;
  //   }

  //   // ✅ Search in allProducts (which should always have every product by ID)
  //   const product = allProducts.find(p => p.id === productId);

  //   if (product) {
  //     setSelectedProduct(product);
  //     setShowQuickView(true);
  //     // fetchProducts(); // optional: probably not needed here
  //   } else {
  //     console.warn("Product not found in allProducts:", productId);
  //   }
  // };
  const handleQuickAdd = (productId) => {
    const token = getAuthToken();
    if (!token) {
      setShowLoginModal(true);
      return;
    }

    const product =
      filteredProducts.find(p => p.id === productId) ||
      allProducts.find(p => p.id === productId);

    if (product) {
      setSelectedProduct(product);
      setShowQuickView(true);
    } else {
      console.warn("Product not found:", productId);
    }
  };

  const handleClose = () => setShowQuickView(false);


  const handleSortChange = async (e) => {
    const sortValue = e.target.value;
    setSortBy(sortValue);

    if (sortValue === "featured") {

      await fetchFeaturedProducts();
      return;
    }


    const fullProducts = await fetchProducts(false);

    let sortedProducts = [...(fullProducts && fullProducts.length ? fullProducts : (allProducts.length ? allProducts : products))];

    switch (sortValue) {
      case 'priceLowHigh':
        sortedProducts.sort((a, b) => a.price - b.price);
        break;
      case 'priceHighLow':
        sortedProducts.sort((a, b) => b.price - a.price);
        break;
      case 'rating':
        sortedProducts.sort((a, b) => b.rating - a.rating);
        break;
      case 'offer': // Filter products with offers
        sortedProducts = sortedProducts.filter((product) => product.hasOffer);
        break;
      default:
        await fetchProducts();
        return;
    }


    setFilteredProducts(sortedProducts);

    setProducts(sortedProducts);
  };



  const toggleFilters = () => setShowFilters(!showFilters);


  const toggleWishlist = async (product) => {
    const token = getAuthToken();


    if (!token) {
      setShowLoginModal(true);
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/wishlist",
        { product_id: product.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (res.data.message === "Unauthenticated.") {
        setShowLoginModal(true);
        return;
      }

      if (res.data.status === true) {
        if (res.data.message === "Removed") {
          setWishlist(wishlist.filter((id) => id !== product.id));
          Swal.fire({
            toast: true,
            icon: "info",
            title: "Removed from Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          fetchProducts();
        } else {
          setWishlist([...wishlist, product.id]);
          setShowWishlist(true);
          fetchProducts()
          Swal.fire({
            toast: true,
            icon: "success",
            title: "Added to Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
      } else {
        Swal.fire({
          toast: true,
          icon: "info",
          title: res.data.message || "Already in Wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);

      if (error.response?.status === 401) {
        setShowLoginModal(true);
      }

      if (error.response?.status === 409) {
        Swal.fire({
          toast: true,
          icon: "info",
          title: error.response.data?.message || "Already in Wishlist",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          toast: true,
          icon: "error",
          title: "Something went wrong!",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    }
  };


  const handleShare = async (productId) => {
    const shareUrl = `${window.location.origin}/productDetails/${productId}`;

    if (navigator.share) {

      try {
        await navigator.share({
          title: "Check out this product",
          url: shareUrl,
        });
      } catch (err) {
        console.error("Share cancelled or failed", err);
      }
    } else {

      try {
        await navigator.clipboard.writeText(shareUrl);
        Swal.fire({
          toast: true,
          icon: "success",
          title: "Link copied to clipboard!",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } catch (err) {
        console.error("Failed to copy link", err);
      }
    }
  };

  const handlePriceFilter = (min, max) => {
    setPriceRange([min, max]);

    const minVal = parseFloat(min) || 0;
    const maxVal = parseFloat(max) || Infinity;

    const filtered = products.filter(
      (p) => p.price >= minVal && p.price <= maxVal
    );

    setFilteredProducts(filtered);
  };


  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container-fluid py-4 ">
      <WishListModal
        show={showWishlist}
        onHide={() => {
          setShowWishlist(false);
          fetchProducts();
        }}
        wishlistItems={products.filter(p => wishlist.includes(p.id))}
        onRemove={(id) => setWishlist(prev => prev.filter(pid => pid !== id))}
      />
      <div className="row mb-4">

        <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">


          <div className="d-flex justify-content-between align-items-center w-100 flex-wrap flex-md-nowrap">

            <button
              className="btn custom-filter-btn"
              onClick={toggleFilters}
            >
              <i className={`bi ${showFilters ? 'bi-x' : 'bi-filter'} me-1`}></i>
              Filters
            </button>

            <div className="d-flex align-items-center">

              <span className="me-2 text-muted d-none d-md-inline">Sort by:</span>

              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={sortBy}
                onChange={handleSortChange}
              >
                <option value="all" >Sort by (Default)</option>
                <option value="featured">Featured</option>
                <option value="priceLowHigh">Price: Low to High</option>
                <option value="priceHighLow">Price: High to Low</option>
                <option value="offer">Offer Items</option>
                {/* <option value="rating">Customer Rating</option> */}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="text-muted small mt-2">
        {filteredProducts.length} Products Found |
      </div><br />

      <div className="row">
        <div className="col-12">
          <div className="row row-cols-2 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 g-3">
            {loading
              ? Array.from({ length: 8 }).map((_, i) => <ProductSkeleton key={i} />)
              : currentProducts.map(product => (
                <div key={product.id} className="col">
                  <div className="card h-100 product-card">
                    <div className="position-relative overflow-hidden">
                      <img
                        onClick={() => navigate(`/productDetails/${product.product_id}`)}
                        src={product.image}
                        className="card-img-top"
                        alt={product.name}
                        onError={(e) => (e.target.src = Noimage)}
                        style={{ height: '300px', objectFit: 'cover' }}

                      />

                      <div className="position-absolute top-0 start-0 m-2">
                        {product.isNew && <span className="badge bg-primary">New</span>}


                        {product.stock === 0 ? (
                          <span className="badge bg-dark ms-1">Out of Stock</span>
                        ) : (
                          product.isSale && <span className="badge bg-danger ms-1">Sale</span>
                        )}

                      </div>




                      <div className="position-absolute top-0 end-0 m-2 d-flex flex-column align-items-end gap-2">

                        <button
                          className="btn btn-light rounded-circle shadow-sm"
                          style={{ width: "40px", height: "40px" }}
                          onClick={() => toggleWishlist(product)}
                        >
                          {product.is_wishlisted ? (
                            <FaHeart className="text-dark" />
                          ) : (
                            <FaRegHeart className="text-dark" />
                          )}
                        </button>


                        <button
                          className="btn btn-light rounded-circle shadow-sm"
                          style={{ width: "40px", height: "40px" }}
                          onClick={() => handleShare(product.product_id)}
                        >
                          <i className="bi bi-share text-dark"></i>
                        </button>
                      </div>

                      <div
                        className="product-actions position-absolute bottom-0 start-0 end-0 p-2 d-flex justify-content-center"
                        style={{ background: "transparent" }}
                      >
                        {product.stock === 0 ? (
                          <button
                            className="btn rounded-pill px-3 out-of-stock-btn"
                            style={{
                              backgroundColor: "#6c757d",
                              color: "#fff",
                              cursor: "not-allowed",
                              fontWeight: "600",
                            }}
                            disabled
                          >
                            OUT OF STOCK
                          </button>
                        ) : (
                          <button
                            className="btn add-to-cart-btn rounded-pill px-3"
                            style={{
                              backgroundColor: "#7c0046",
                              color: "#fff",
                            }}
                            onClick={() => handleQuickAdd(product.id)}
                          >
                            ADD TO CART
                          </button>
                        )}
                      </div>

                    </div>

                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="card-title mb-0 fs-6">{product.name}</h6>

                      </div>

                      <div className="mt-2">
                        <div className="d-flex align-items-center flex-wrap">
                          <span className="h6 mb-0 fw-bold" style={{ color: "#7c0046" }}>
                            ₹&nbsp;{product.price.toFixed(2)} {product.hasOffer && (
                              <span className="offer-badge">
                                <i className="bi bi-tag-fill" style={{ color: "#FFD700" }}></i>
                              </span>
                            )}
                          </span>
                          {product.originalPrice > product.price && (
                            <span className="text-muted text-decoration-line-through ms-2 small">
                              ₹&nbsp;{product.originalPrice.toFixed(2)}
                            </span>
                          )}
                          {product.discountPercent > 0 && (
                            <span className="fw-semibold ms-2 d-none d-sm-inline" style={{
                              color: 'red',

                              fontSize: '0.9rem',
                            }}>
                              {product.discountPercent}% OFF
                            </span>
                          )}
                        </div>

                        {/* Show on mobile below the price */}
                        {product.discountPercent > 0 && (
                          <div className="d-block d-sm-none mt-1">
                            <span className="fw-semibold" style={{
                              color: 'red',
                              fontSize: '0.9rem',
                            }}>
                              {product.discountPercent}% OFF
                            </span>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              ))}
          </div>
          {filteredProducts.length > productsPerPage && (
            <nav className="mt-4">
              <ul className="pagination justify-content-center" style={{ gap: "8px" }}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item`}
                    style={{ borderRadius: "6px", overflow: "hidden" }}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(i + 1)}
                      style={{
                        minWidth: "40px",
                        height: "40px",
                        color: currentPage === i + 1 ? "#fff" : "#000",
                        backgroundColor: currentPage === i + 1 ? "#000" : "#fff",
                        border: "1px solid #000",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={e => {
                        if (currentPage !== i + 1) {
                          e.target.style.backgroundColor = "#000";
                          e.target.style.color = "#fff";
                        }
                      }}
                      onMouseLeave={e => {
                        if (currentPage !== i + 1) {
                          e.target.style.backgroundColor = "#fff";
                          e.target.style.color = "#000";
                        }
                      }}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}


        </div>
      </div>
      <>

        <div
          className={`filter-backdrop ${showFilters ? 'show' : ''}`}
          onClick={toggleFilters}
        />

        <FilterSidebar
          showFilters={showFilters}
          toggleFilters={toggleFilters}
          categories={categories}
          selectedCategory={selectedCategory}
          handleCategoryFilter={handleCategoryFilter}
          selectedSubCategory={selectedSubCategory}
          handleSubCategoryFilter={handleSubCategoryFilter}

          minPrice={priceRange[0]}
          maxPrice={priceRange[1]}
          handlePriceFilter={handlePriceFilter}
        />

        <ProductModal
          show={showQuickView}
          onHide={handleClose}
          product={selectedProduct}
          onCartSuccess={(product) => {
            setSelectedProduct(product);
            setShowQuickViewModal(true);
          }}
        />

        <QuickViewModal
          show={showQuickViewModal}
          onHide={() => setShowQuickViewModal(false)}
        />

        {showLoginModal && (
          <LoginModal
            show={showLoginModal}
            handleClose={() => setShowLoginModal(false)}
            handleLoginSuccess={(userData) => {

              localStorage.setItem("auth_token", userData.token);
              setShowLoginModal(false);
            }}
          />
        )}
      </>

      <style jsx>{`
        .product-card {
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .product-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        .list-group-item.active {
          background-color: #000;
          border-color: #000;
        }
        .form-range::-webkit-slider-thumb {
          background: #000;
        }
        .form-range::-moz-range-thumb {
          background: #000;
        }
        /* Sidebar */
        .filter-sidebar {
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          width: 300px;
          background: #fff;
          padding: 20px;
          z-index: 1040;
          transform: translateX(-100%);
          transition: transform 0.3s ease-in-out;
          overflow-y: auto;
        }
        .filter-sidebar.open {
          transform: translateX(0);
        }
      .custom-filter-btn {
  border: 1px solid #1c3f1d;
  color: #1c3f1d;
  background-color: transparent;
}

.custom-filter-btn:hover {
  background-color: #1c3f1d;
  color: #fff;
}

.add-to-cart-btn {
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  border-radius: 50px !important; 
  padding: 8px 20px; 
}


.product-card:hover .add-to-cart-btn {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.product-card {
          transition: transform 0.2s, box-shadow 0.2s;
          border: none;
          overflow: hidden;
        }
        .product-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        
      
        .position-relative {
          // overflow: hidden;
        }
        
       
        .product-actions {
          transform: translateY(100%);
          transition: transform 0.3s ease;
          background: rgba(255, 255, 255, 0.9);
        }
        
        .add-to-cart-btn {
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          padding: 0.5rem 1.2rem;
          text-transform: uppercase;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        /* Show button on hover */
        .product-card:hover .product-actions {
          transform: translateY(0);
        }
        
        .product-card:hover .add-to-cart-btn {
          opacity: 1;
        }
        
        /* Card body improvements */
        .card-body {
          padding: 1rem;
        }
        
        .card-title {
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }
        
        /* Backdrop */
        .filter-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease-in-out;
          z-index: 1039;
        }
        .filter-backdrop.show {
          opacity: 1;
          pointer-events: auto;
        }
          .skeleton {
  background: linear-gradient(90deg, #eee, #f5f5f5, #eee);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 8px;
}

.skeleton-img {
  height: 300px;
  width: 100%;
}

.skeleton-text {
  height: 16px;
  margin-top: 8px;
}
@media (max-width: 768px) {
 .product-card img {
    height: 200px !important; /* reduce image height */
    object-fit: cover;
  }
.product-card .btn.btn-light.rounded-circle {
    width: 30px !important;
    height: 30px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .product-card .btn.btn-light.rounded-circle i,
  .product-card .btn.btn-light.rounded-circle svg {
    font-size: 0.8rem !important;
  }
  .product-card {
    border-radius: 10px;
  }

  .card-body {
    padding: 0.6rem !important;
  }

  .card-title {
    font-size: 0.85rem !important;
  }

  .product-card .h6 {
    font-size: 0.9rem !important;
  }

  .product-card .btn.add-to-cart-btn {
    font-size: 0.75rem !important;
    padding: 5px 12px !important;
  }
}
  .add-to-cart-btn {
    opacity: 1 !important;
    visibility: visible !important;
    transform: translateY(0) !important;
  }

  .product-actions {
    transform: translateY(0) !important;
  }
    .out-of-stock-btn {
    display: none !important;
  }
}
@keyframes skeleton-loading {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

      `}</style>
    </div>
  );
};

export default ProductListing;


